import { apiClient, createSuccessResponse, handleApiError } from "./api";


const customerService = {

    async listCustomer(page = 1, pageSize = 10, filters = {}, sortBy = null, sortOrder = null) {
        try {

            const params = new URLSearchParams({
                page: page.toString(),
                pageSize: pageSize.toString(),
                ...filters
            });

            // Adicionar parâmetros de ordenação se fornecidos
            if (sortBy) {
                params.append('sortBy', sortBy);
            }
            if (sortOrder) {
                params.append('sortOrder', sortOrder);
            }

            const retorno = await apiClient.get(`/customer?${params.toString()}`);

            return {
                data: retorno.data.data,
                pagination: retorno.data.pagination,
            };
        } catch (error) {
            const processedError = handleApiError(error);
            console.error("❌ [customerService] Erro ao listar clientes:", processedError);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    /**
     * @method isCpjCnpjAvailable
     * @description Verifica se o CPF/CNPJ está disponível
     * @param {string} cpfCnpj - CPF/CNPJ a ser verificado
     * @param {number|null} excludeId - ID do cliente a ser excluído da validação (ao editar)
     * @returns {Promise<Object>} Promise com o resultado da verificação
     */
    async isCpjCnpjAvailable(cpfCnpj, excludeId = null) {
        try {
            const payload = { cpfCnpj };
            if (excludeId) {
                payload.excludeId = excludeId;
            }
            
            const retorno = await apiClient.post('/customer/is-cpf-cnpj-available', payload);
            console.log(retorno.data)
            if (retorno.data.available) {
                return {
                    success: true,
                    message: "CPF/CNPJ disponível",
                    status: 200,
                    data: retorno.data
                }
            } else {
                return {
                    success: false,
                    message: "CPF/CNPJ não disponível",
                    status: 400,
                    data: retorno.data
                }
            }
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async listCustomerActive(page = 1, pageSize = 10) {
        try {
            var retorno = await apiClient.get(`/customer/active?page=${page}&pageSize=${pageSize}`);

            return {
                data: retorno.data.data,
                pagination: retorno.data.pagination,
            };
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },


    async listCustomerLocatario(page = 1, pageSize = 10) {
        try {
            var retorno = await apiClient.get(`/customer/locatario?page=${page}&pageSize=${pageSize}`);

            return {
                data: retorno.data.data,
                pagination: retorno.data.pagination,
            };
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async listCustomerFilter(id) {
        try {
            console.log(id)

            var retorno = await apiClient.get('/customer/filter/' + id);

            return {
                data: retorno.data.data,
                pagination: retorno.data.pagination,
            };
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },


    async editCustomer(id) {
        try {
            var retorno = await apiClient.get("/customer/" + id);
            console.log(retorno.data)
            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async save(customer) {
        try {
            console.log(customer)

            var retorno = await apiClient.post("/customer", customer);

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async update(customer) {
        try {
            console.log(customer)

            var retorno = await apiClient.put("/customer", customer);

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async delete(idcustomer) {
        try {
            console.log(idcustomer)

            var retorno = await apiClient.delete("/customer/" + idcustomer);

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    }

}

export default customerService;